const url = "/api/v1/profile_details";

export interface ProfileDetailsUpdateParams {
  currentlyTrying: string[] | null;
  goal: string | null;
  gratefulFor: string | null;
  location: string | null;
  moreAboutMe: string | null;
  partnerName: string | null;
  partnerType: string | null;
  previouslyTried: string[] | null;
  tripTomorrow: string | null;
  tryingSince: string | null;
  typicalWeek: string | null;
  whoIAm: string | null;
}

export const profileDetailsUpdateQuery = (
  params: ProfileDetailsUpdateParams,
) => ({
  url,
  method: "PUT",
  body: params,
});
